import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const DialogHeader = props => {
    const { title, subtitle, headerButtons, showCloseButton, onClose } = props, remainingProps = __rest(props, ["title", "subtitle", "headerButtons", "showCloseButton", "onClose"]);
    return (_jsxs("div", Object.assign({}, remainingProps, { className: 'modal-header' }, { children: [_jsxs("div", Object.assign({ className: 'modal-header-text' }, { children: [subtitle && _jsx("div", Object.assign({ className: 'modal-header-subtitle' }, { children: subtitle })), _jsx("div", Object.assign({ className: 'modal-header-title' }, { children: title }))] })), _jsxs("div", Object.assign({ className: 'modal-header-buttons' }, { children: [headerButtons && (_jsxs(React.Fragment, { children: [headerButtons, _jsx("div", { className: 'modal-header-buttons-spacer' })] })), showCloseButton && (_jsx("button", Object.assign({ type: 'button', className: 'btn btn-icon-only btn-muted modal-header-close close', onClick: onClose, "data-testid": 'close' }, { children: _jsx("span", { className: 'rioglyph rioglyph-remove', "aria-hidden": 'true' }) })))] }))] })));
};
DialogHeader.defaultProps = {
    showCloseButton: true,
    onClose: () => { },
};
DialogHeader.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    showCloseButton: PropTypes.bool,
    onClose: PropTypes.func,
    headerButtons: PropTypes.node,
};
export default DialogHeader;
